import FormatPriceTVOD from "@/components/FormatPriceTVOD";
import dayjs from "@/lib/day";
import { jsx as _jsx } from "react/jsx-runtime";
export function price(item) {
  const {
    rights
  } = item;
  const prices = rights.map(right => right.price);
  const price = prices.reduce((a, b) => Math.min(a, b));
  const ext = prices.length > 1 ? "から" : null;
  return /*#__PURE__*/_jsx(FormatPriceTVOD, {
    price: price,
    ext: ext
  });
}
export function deliveryDate(item) {
  let onlyStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!item) return null;
  let start = "delivery_start_at";
  let end = "delivery_end_at";
  if (!item[start]) return null;
  const startAt = dayjs(new Date(item[start]));
  const format = "YYYY/M/D";
  let deliveryDate = `${startAt.format(format)} -`;
  if (item[end] && !onlyStart) {
    const endAt = dayjs(new Date(item[end]));
    deliveryDate = `${deliveryDate} ${endAt.format(format)}`;
  }
  return deliveryDate;
}
export function deliveryLabel(item) {
  if (!item) return null;
  if (item.__typename !== "EpisodeMeta") return null;
  const now = dayjs();
  const deliveryStart = dayjs(new Date(item.delivery_start_at));
  const deliveryEnd = dayjs(new Date(item.delivery_end_at));
  let delivery = false;
  if (item.delivery_start_at && item.delivery_end_at) {
    delivery = now.isBetween(deliveryStart, deliveryEnd, null, "[)");
  } else if (item.delivery_start_at && !item.delivery_end_at) {
    delivery = now.isSameOrAfter(deliveryStart);
  } else if (!item.delivery_start_at && item.delivery_end_at) {
    delivery = now.isBefore(deliveryEnd);
  }
  if (delivery && item.delivery_end_at && deliveryEnd.diff(now, "hours") < 72) {
    return "まもなく配信終了";
  } else if (!delivery && deliveryStart.isAfter(now)) {
    return "配信前";
  }
  return null;
}
export function liveStatus(item) {
  if (!item) return null;
  if (item.__typename !== "LiveMeta") return null;
  const now = dayjs();
  const deliveryStart = dayjs(new Date(item.delivery_start_at));
  const deliveryEnd = dayjs(new Date(item.delivery_end_at));
  let status = false;
  if (item.delivery_start_at && item.delivery_end_at) {
    status = now.isBetween(deliveryStart, deliveryEnd, null, "[)");
  } else if (item.delivery_start_at && !item.delivery_end_at) {
    status = now.isSameOrAfter(deliveryStart);
  } else if (!item.delivery_start_at && item.delivery_end_at) {
    status = now.isBefore(deliveryEnd);
  }
  return status;
}
export function liveStatusLabel(item) {
  const status = liveStatus(item);
  const now = dayjs();
  const deliveryStart = dayjs(new Date(item.delivery_start_at));
  if (status == null) return null;
  if (status) {
    return "LIVE";
  } else if (item.delivery_start_at && deliveryStart.isAfter(now)) {
    return "配信前";
  } else {
    return "";
  }
}
export function liveStartDate(item) {
  let expanded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (!item || !item.delivery_start_at) return null;
  if (expanded) {
    return dayjs(item.delivery_start_at).format("YYYY M/D H:mm 開始");
  } else {
    return dayjs(item.delivery_start_at).format("M/D H:mm 開始");
  }
}
export function channelTag(item) {
  const tag = [];
  if (item.live_flag) {
    tag.push("ライブ配信");
  }
  if (item.video_flag) {
    tag.push("オンデマンド");
  }
  return tag.join(" + ");
}
export function isEnded(endDate) {
  if (typeof endDate == "undefined" || endDate == "" || endDate == null) {
    return false;
  }
  return dayjs().isAfter(dayjs(new Date(endDate)));
}